import { createReducer } from '../../helpers/reducer';
import actions from './actions';
import { IFeatureFlagsState, IFeatureFlagsData } from './types';

const initState: IFeatureFlagsState = {
  flags: null,
  isLoading: false,
};

function onFetchRequest(state: IFeatureFlagsState) {
  return { ...state, isLoading: true };
}

function onFetchSuccess(state: IFeatureFlagsState, { payload }: { payload: IFeatureFlagsData }) {
  return { ...state, flags: payload, isLoading: false };
}

function onFetchError(state: IFeatureFlagsState) {
  return { ...state, isLoading: false };
}

export default createReducer(initState, {
  [actions.FETCH_FEATURE_FLAGS_REQUEST]: onFetchRequest,
  [actions.FETCH_FEATURE_FLAGS_SUCCESS]: onFetchSuccess,
  [actions.FETCH_FEATURE_FLAGS_ERROR]: onFetchError,
});
